import React, { useEffect, useState } from "react";
import moment from "moment";

import {
  FaSearch,
  FaCloudflare,
  FaRegUserCircle,
  FaWaveSquare,
} from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { getAllActivites } from "../store/actions/activities";
import { getUserCountStatics } from "../store/actions/user";

const Dashboard = () => {
  const dispatch = useDispatch();

  const [activityList, setActivityList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [dates, setDates] = useState({
    fromDate: new Date().toISOString().split("T")[0],
    toDate: new Date().toISOString().split("T")[0],
  });
  const [statCount, setStatCount] = useState("");
  const [showCloseButton, setShowCloseButton] = useState(false);
  const [filterQuery, setFilterQuery] = useState({
    limit: "10",
    page: "1",
    createdAt: {
      lte: moment(dates.toDate).endOf("day").toISOString(),
      gte: moment(dates.fromDate)
        .startOf("day")
        .subtract(7, "days")
        .toISOString(),
    },
  });

  // redux logic
  const activities = useSelector((state) => state.activities);

  const getActivityList = () => {
    dispatch(getAllActivites(filterQuery));
  };

  useEffect(() => {
    getActivityList();
  }, [dispatch, filterQuery, setFilterQuery]);

  useEffect(() => {
    dispatch(getUserCountStatics()).then((result) => {
      if (result?.payload?.success) {
        //  console.log(result?.payload?.counts);
        setStatCount(result?.payload?.counts);
      }
    });
  }, [dispatch]);

  useEffect(() => {
    setActivityList(activities.activityList);
  }, [activities]);

 
  const handleSearchText = (e) => {
    setSearchText(e.target.value);
  };
  const handleSearch = (e) => {
    e.preventDefault();
    setFilterQuery({
      ...filterQuery,
      keyword: e.target.defaultSearch.value,
      keywordName: ["types", "message"],
    });
    setShowCloseButton(true);
  };
  const handleClearSearch = () => {
    delete filterQuery.keyword;
    delete filterQuery.keywordName;
    setFilterQuery({ ...filterQuery });
    setSearchText("");
    setShowCloseButton(false);
  };
 

  return (
    <div className="relative">
      <div className=" bg-top p-2  fixed  w-full lg:max-w-[calc(100%-16rem)] z-10 h-screen !bg-[#cbd5e0]">
        <div className="w-full flex items-center justify-between p-1  gap-4">
          <div className="text-text text-lg font-medium">Dashboard</div>
          <div className="relative ">
            <form className=" flex w-full " onSubmit={handleSearch}>
              <span className="absolute inset-y-0 left-0 flex items-center pl-3  text-gray-500">
                <FaSearch />
              </span>

              <input
                type="text"
                id="default-search"
                value={searchText}
                onChange={handleSearchText}
                name="defaultSearch"
                placeholder="Search..."
                className="w-[275px]  pl-10 pr-4 py-2 text-gray-500 border border-gray-300 rounded-lg focus:outline-none focus:ring-0 focus:ring-blue-500"
              />
              <button
                type="submit"
                className="text-white  absolute right-0 bottom-1 top-1 bg-blue-700 hover:bg-blue-800  focus:outline-none focus:ring-0 font-medium rounded-lg text-sm px-4 py-0 mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              >
                Search
              </button>
              {showCloseButton && (
                <button
                  type="submit"
                  className="text-red-600 text-bold absolute right-20 bottom-1 top-1  focus:outline-none focus:ring-0 font-medium rounded-lg text-sm px-2 py-0 mr-2  "
                  onClick={handleClearSearch}
                >
                  X
                </button>
              )}
            </form>
          </div>
        </div>

        {/* <div className="flex flex-col lg:flex-row justify-center items-center gap-4  "> */}
        <div className="grid gap-4 lg:grid-cols-3 md:grid-cols-2 grid-cols-2">
          <div className="bg-card p-4 lg:my-3  rounded-lg shadow-lg w-full">
            <div className="flex items-center lg:flex-row justify-between gap-2">
              <h4 className="text-text font-medium text-base">Total RDP</h4>
              <div className="bg-red-500 p-2 rounded-full">
                <FaCloudflare className="text-2xl text-white" />
              </div>
            </div>

            <div className="flex justify-between items-center">
              {/* Left Section */}
              <div className="flex flex-col">
                {/* Main Statistic */}
                <h5 className="text-base font-medium text-text">
                  {statCount?.rdps}
                </h5>
              </div>
              {/* Right Section */}
              <div>
                <p className="text-sm font-medium text-text">
                  currently active Rdps
                </p>
              </div>
            </div>
          </div>

          <div className="bg-card p-4 lg:my-3  rounded-lg shadow-lg w-full ">
            <div className="flex items-center lg:flex-row justify-between gap-2">
              <h4 className="text-text font-medium text-base">Total User</h4>
              <div className="bg-red-500 p-2 rounded-full">
                <FaRegUserCircle className="text-2xl text-white" />
              </div>
            </div>

            <div className="flex justify-between items-center">
              {/* Left Section */}
              <div className="flex flex-col">
                {/* Main Statistic */}
                <h5 className="text-base font-medium text-text">
                  {statCount?.users}
                </h5>
              </div>

              {/* Right Section */}
              <div>
                <p className="text-sm font-medium text-text">
                  currently active Users
                </p>
              </div>
            </div>
          </div>

          <div className="bg-card p-4 lg:my-3  rounded-lg shadow-lg w-full ">
            <div className="flex items-center lg:flex-row justify-between gap-2">
              <h4 className="text-text font-medium text-base">Activities</h4>
              <div className="bg-red-500 p-2 rounded-full">
                <FaWaveSquare className="text-2xl text-white" />
              </div>
            </div>

            <div className="flex justify-between items-center">
              {/* Left Section */}
              <div className="flex flex-col">
                {/* Main Statistic */}
                <h5 className="text-base font-medium text-text">
                  {statCount?.activity}
                </h5>
              </div>

              {/* Right Section */}
              <div>
                <p className="text-sm font-medium text-text">
                  Todays Login attempts
                </p>
              </div>
            </div>
          </div>

          {/* <div className="bg-card p-4 lg:my-3  rounded-lg shadow-lg w-full ">
            <div className="flex items-center lg:flex-row justify-between gap-2">
              <h4 className="text-text font-medium text-base">WALLET</h4>
              <div className="bg-red-500 p-2 rounded-full">
                <RiWallet3Line className="text-2xl text-white" />
              </div>
            </div>

            <div className="flex justify-between items-center">
              {/* Left Section 
              <div className="flex flex-col">
                {/* Main Statistic 
                <h5 className="text-base font-medium text-text">350,897</h5>

                {/* Growth Indicator 
                <div className="flex items-center gap-1 text-green-400">
                  <FaArrowUpLong className="text-lg" />
                  <span className="text-sm font-medium">3.48%</span>
                </div>
              </div>

              {/* Right Section 
              <div>
                <p className="text-sm font-medium text-text">
                  Since last month
                </p>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
